export default function copyTimeplanUnitsFromDateToDates(timeplanUnits, fromDate, toDates) {
  const copies = timeplanUnits.filter(tpu => tpu.date === fromDate);
  const tpuDates = timeplanUnits.map(tpu => tpu.date);
  const toDatesWithTPU = toDates.filter(date => tpuDates.includes(date));
  const currentTimeplanUnits = timeplanUnits.filter(tpu => !toDatesWithTPU.includes(tpu.date));
  return toDatesWithTPU.reduce((periods, date) => (
    periods.push(...copies.map((tpu, index) => (
      tpu.merge({ date, id: `${date}-${index}` })
    )))
  ), currentTimeplanUnits);
}
